import { FC, useEffect, useState, useReducer, useRef } from 'react';
import { Box, Paper, FormGroup, FormControl, FormControlLabel, Select, InputLabel, MenuItem, Button, TextField, Checkbox, SelectChangeEvent } from '@mui/material';
import Customer from './customer';
import { Topic } from './customer';
import StorylineServerProxy  from "../storyline-proxy/storyline-proxy";
 
export interface CustomerProps {
    customer: Customer,
    customerDispatch: any
}


export const CustomerProperties: FC<CustomerProps> = ({ customer, customerDispatch }) =>  {
    let [allUsers, setAllUsers] = useState([] as string[]);

    useEffect(() => {
        StorylineServerProxy.getUsers().then((allUsers) => {
            let allUsernames = [] as string[];
            allUsers.map(user => allUsernames.push(user.username));
            setAllUsers(allUsernames);
        });
    }, []);

    return(
        <>
            <FormControl fullWidth sx={{paddingTop: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-around'}}>
                <FormGroup row>
                    <InputLabel id="lead-select-label">Lead</InputLabel>
                    <Select labelId="lead-select-label" sx={{ width: 1/6 }} onChange={event => customerDispatch({lead: event?.target.value})} value={allUsers.length!=0?customer.lead: ""}>
                        {allUsers.map((username) => { return <MenuItem value={username}>{username}</MenuItem> })};
                    </Select>
                    <TextField sx={{width: 2/3, marginLeft:1}}  label={"Emails"} onChange={event => customerDispatch({emails: event?.target.value})} value={customer.emails}/>
                    <TextField sx={{width: 2/3, marginLeft:1}}  label={"Emails cc"} onChange={event => customerDispatch({emailsCC: event?.target.value})} value={customer.emailsCC}/>
                    <TextField sx={{width: 2/3, marginLeft:1}}  label={"Title"} onChange={event => customerDispatch({emailTitle: event?.target.value})} value={customer.emailTitle}/>
                    <TextField sx={{width: 2/3, marginLeft:1}}  label={"Interval"} onChange={event => customerDispatch({interval: event?.target.value})} value={customer.interval}/>
                    <Select sx={{ width: 1/6 }} onChange={event => customerDispatch({sorting: event?.target.value})} value={allUsers.length!=0?customer.sorting: "date"}>
                        <MenuItem value="dateOnly">Date</MenuItem>
                        <MenuItem value="typeDate">Type and date</MenuItem>
                    </Select>
                    <FormControlLabel control={<Checkbox onChange={event => customerDispatch({includeJobs: event?.target.checked})} checked={customer.includeJobs}/>} label="Include jobs" />
                    <FormControlLabel control={<Checkbox onChange={event => customerDispatch({includeKeywords: event?.target.checked})} checked={customer.includeKeywords}/>} label="Include keywords in report" />
                </FormGroup>
                <FormGroup row sx={{ paddingTop:3 }}>
                    <TextField sx={{width: 1 }}label={"Email body"} rows={5} multiline onChange={event => customerDispatch({emailBody: event?.target.value})} value={customer.emailBody}/>
                </FormGroup>
            </FormControl>
        </>
    )
}

export const CustomerCreator = () =>  {

    let [customer, customerDispatch] = useReducer(function (state: Customer, action: any){
            let reduced = { ...state, ...action };
            return reduced;
        } , 
        new Customer("Customer name", "emails, sepearated by a comma", "cc emails, sepearated by a comma", "Email title", "Dear XXX, please find... blah", "vincent", true, false, [], "7", "dateOnly")
    );


    function handleCreateClicked(){
        StorylineServerProxy.createCustomer(customer).then(() => {
            alert("New customer created");
            new Customer("Customer name", "emails, sepearated by a comma", "cc emails, sepearated by a comma", "Email title", "Dear XXX, please find... blah", "vincent", true, false, [], "7", "dateOnly");
        });
    }



    return(
        <>
            <TextField sx={{ width: 1/2 }} label={"New customer name"} value={customer.name} onChange={(event) => customerDispatch({name: event.target.value})}/>
            <br/>
            <CustomerProperties customer={customer} customerDispatch={customerDispatch}></CustomerProperties>
            <br/>
            <Button onClick={handleCreateClicked}>Create</Button>
        </>
    )
}


export const CustomerEditor = () => {

    let [customers, setCustomers] = useState([] as Customer[]);

    let [selectedCustomerName, setSelectedCustomerName] = useState("");

    let [customer, customerDispatch]= useReducer(function (state: Customer, action: any){
        let reduced = { ...state, ...action };
        return reduced;
    } , 
    new Customer("Customer name", "emails, sepearated by a comma", "cc emails, sepearated by a comma", "Email title", "Dear XXX, please find... blah", "vincent", true, false, [], "7", "dateOnly"));



    useEffect(() => {
        StorylineServerProxy.getCustomers().then(customersFromServer => {
            setCustomers(customersFromServer);
        });
    },
    []);

    useEffect(() => {
        
        for(let currentCustomer of customers){
            if(currentCustomer.name == selectedCustomerName){
                customerDispatch({...currentCustomer});
            }
        }
    }, [selectedCustomerName]);

    function handleCustomerSelected(event: SelectChangeEvent){
        for(let currentCustomer of customers){
            if(currentCustomer.name == event.target.value){
                setSelectedCustomerName(event.target.value);
            }
        }        
    }

    function handleUpdateClicked(){
        StorylineServerProxy.updateCustomer(customer).then(() => {
            StorylineServerProxy.getCustomers().then(customersFromServer => {
                setCustomers(customersFromServer);
            });
        });
    } 
    
    function updateTopics(topicIndex: number, keywordIndex: number, keyword: string){
        let topics = [...customer.topics];
        topics[topicIndex].keywords[keywordIndex] = keyword;
        customerDispatch({ topics: topics });
    }

    function deleteTopic(topicIndex: number){
        let topics = [...customer.topics];
        topics.splice(topicIndex, 1);
        customerDispatch({ topics: topics });
    }


    function deleteKeyword(topicIndex: number, keywordIndex: number){
        let topics = [...customer.topics];
        topics[topicIndex].keywords.splice(keywordIndex, 1);
        customerDispatch({ topics: topics });
    }

    let newTopicRef = useRef("");

    function handleCreateNewTopic(){
        let topics = [...customer.topics];
        topics.push(new Topic(newTopicRef.current.value, []));
        customerDispatch({ topics: topics });
    }

    function handleAddQuery(topicIndex: number){
        let topics = [...customer.topics];
        topics[topicIndex].keywords.push("");
        customerDispatch({ topics: topics });
    }

    return(
        <>
        <FormControl fullWidth sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-around'}}>
            <Box sx={{ marginTop: 0,  paddingTop: 1}}>
                <InputLabel id="customer-select-label">Customer</InputLabel>
                <Select sx={{width: 1/2}} labelId="customer-select-label" value={selectedCustomerName} onChange={handleCustomerSelected}>
                    {
                        customers.map(customer => <MenuItem value={customer.name}>{customer.name}</MenuItem>)
                    }
                </Select>
            </Box>
            {
                customer?(
                    <>
                        <Paper elevation={6} sx={{ padding: 1, marginTop: 1 }}>
                            <CustomerProperties customer={customer} customerDispatch={customerDispatch}/>
                        </Paper>
                        <Paper sx={{ padding: 1, marginTop: 1 }} elevation={6}>
                            <TextField sx={{ width: 9/10 }} inputRef={newTopicRef} placeholder="New topic name"/>
                            <Button onClick={handleCreateNewTopic}>Create</Button>
                        </Paper>
                        {
                            customer.topics?(
                                customer.topics.map((topic: Topic, topicIndex: number) => {
                                    return (
                                        <>
                                        <Paper elevation={6} sx={{ padding: 1, marginTop: 1 }}>
                                            <h3>{topic.name}</h3>
                                            {
                                                topic.keywords.map((keyword: string, keywordIndex: number) => {
                                                    return (
                                                        <>
                                                            <FormGroup row >
                                                                <TextField sx={{width: 9/10, marginTop: 1}} onChange={(event) => updateTopics(topicIndex, keywordIndex, event?.target.value)} value={keyword}/>
                                                                <Button onClick={() => deleteKeyword(topicIndex, keywordIndex)}>Delete</Button>
                                                            </FormGroup>
                                                        </>
                                                    )
                                                })
                                            }
                                            <Button onClick={() => handleAddQuery(topicIndex)}>Add query</Button>
                                            <Button color="error" onClick={() => deleteTopic(topicIndex)}>Delete topic</Button>
                                        </Paper>
                                        </>
                                    )
                                })
                            ):""
                        }
                        <Paper sx={{ padding: 1, marginTop: 1 }} elevation={6}>
                            <Button onClick={handleUpdateClicked}>Update</Button>  
                        </Paper> 
                    </>
                ):(<></>)
            }
            </FormControl>
        </>
    );
}

export const CustomerDeletor = () => {
    let [customers, setCustomers] = useState([] as Customer[]);
    let [selectedCustomerName, setSelectedCustomerName] = useState("");

    function updateCustomersList(){
        StorylineServerProxy.getCustomers().then(customersFromServer => {
            setCustomers(customersFromServer);
            setSelectedCustomerName("");
        });
    }

    useEffect(() => {
        updateCustomersList();
    },
    []);

    function handleCustomerSelected(event){
        setSelectedCustomerName(event.target.value);
    }

    function handleDeleteClicked(){
        if(window.confirm("Are you sure you want to delete " + selectedCustomerName + "?"))
        {
            StorylineServerProxy.deleteCustomer(selectedCustomerName).then((data) => { updateCustomersList() }).catch((e) => { alert(e) });
        }
    }

    return (
        <>
            Pick a customer:
            <Select value={selectedCustomerName} onChange={handleCustomerSelected}>
                {
                    customers.map(customer => <MenuItem value={customer.name}>{customer.name}</MenuItem>)
                }
            </Select>
            <br/><br/>
            {
                selectedCustomerName != ""?(
                    <>
                        <Button color="error" onClick={handleDeleteClicked}>Delete {selectedCustomerName}</Button>
                    </>
                ):""
            }
        </>
    )
}